export function pxToRem(pixel: number): string {
  return `${pixel / 16}rem`
}

export function pxToEm(pixel: number): string {
  return `${pixel / 16}em`
}

export function convertWeight(name: string): number {
  switch (name) {
    case 'light':
      return 300

    case 'regular':
      return 400

    case 'medium':
      return 500

    case 'demibold':
      return 600

    case 'bold':
      return 700

    default:
      return 500
  }
}
